/* VIVIANNA Handy-Menü (Variante A nach GLDN-Form) — gehört zu snippets/viv-handy-menue.liquid.
   Kümmert sich um das Innere: Tabs wechseln, Gruppen auf- und zuklappen, Unterseiten ein- und ausschieben.
   Öffnen, Schließen, Overlay und Scroll-Sperre macht weiterhin <navigation-drawer> aus assets/theme.js.

   Klickstatistik (Microsoft Clarity), nur bei echten Klicks (isTrusted) und nur, wenn die Kundin der Analyse
   zugestimmt hat (Shopify.customerPrivacy.analyticsProcessingAllowed() === true); sonst wird nichts gesendet.
   Namen, wie Yin sie in Clarity sieht:
     Events:  手机菜单-打开 (Menü geöffnet) · 手机菜单-标签 (Tab gewechselt) · 手机菜单-展开 (Gruppe aufgeklappt)
              手机菜单-子页 (Unterseite geöffnet) · 手机菜单-链接 (Link angetippt)
     Tags:    手机菜单-标签 = Tabname · 手机菜单-展开 = Tab › Gruppe · 手机菜单-子页 = Tab › Gruppe
              手机菜单-链接 = Tab › Gruppe › Link  (Fußleiste: Leiste › Hilfe, Kacheln: Tab › Kachel › Name)
   Ein Klick auf einen Link löst die Seite aus; Clarity sendet seine Warteschlange vorher (sendBeacon). */
(() => {
  if (window.customElements.get('viv-handy-menue')) return;

  const ohneBewegung = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function einwilligung() {
    try {
      const cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed() === true);
    } catch (e) {
      return false;
    }
  }

  function melde(event, tag, wert) {
    if (typeof window.clarity !== 'function' || !einwilligung()) return;
    try {
      window.clarity('event', event);
      if (tag && wert) window.clarity('set', tag, String(wert).slice(0, 255));
    } catch (e) {}
  }

  // Text eines Knopfes oder Links ohne das kleine Schild („Saison“)
  function beschriftung(el) {
    if (!el) return '';
    const kopie = el.cloneNode(true);
    kopie.querySelectorAll('.viv-hm__schild, .sr-only, svg').forEach(x => x.remove());
    return kopie.textContent.replace(/\s+/g, ' ').trim();
  }

  class VivHandyMenue extends HTMLElement {
    connectedCallback() {
      // Der Drawer wird beim Laden an <body> umgehängt; dann läuft connectedCallback ein zweites Mal.
      if (this._bereit) return;
      this._bereit = true;

      this.addEventListener('click', (event) => this._klick(event));
      this.querySelector('[role="tablist"]')?.addEventListener('keydown', (event) => this._tabTaste(event));

      const drawer = this.closest('navigation-drawer');
      if (drawer) {
        drawer.addEventListener('dialog:after-hide', () => this.schliesseUnterseite(true));
        drawer.addEventListener('dialog:after-show', () => melde('手机菜单-打开'));
      }
    }

    get tabs() {
      return Array.from(this.querySelectorAll('[role="tab"]'));
    }

    get tabpanels() {
      return Array.from(this.querySelectorAll('[role="tabpanel"]'));
    }

    get tabName() {
      return beschriftung(this.querySelector('[role="tab"][aria-selected="true"]'));
    }

    _klick(event) {
      const ziel = event.target.closest('[data-viv-tab], .viv-hm__acc-btn, [data-viv-sub], [data-viv-back], a[href]');
      if (!ziel || !this.contains(ziel)) return;
      const echt = event.isTrusted === true;

      if (ziel.hasAttribute('data-viv-tab')) {
        this.zeigeTab(Number(ziel.dataset.vivTab));
        if (echt) melde('手机菜单-标签', '手机菜单-标签', beschriftung(ziel));
      } else if (ziel.classList.contains('viv-hm__acc-btn')) {
        const offen = this.klappe(ziel);
        if (echt && offen) melde('手机菜单-展开', '手机菜单-展开', this.tabName + ' › ' + beschriftung(ziel));
      } else if (ziel.hasAttribute('data-viv-sub')) {
        this.oeffneUnterseite(ziel);
        if (echt) melde('手机菜单-子页', '手机菜单-子页', this.tabName + ' › ' + beschriftung(ziel));
      } else if (ziel.hasAttribute('data-viv-back')) {
        this.schliesseUnterseite(false);
      } else if (echt) {
        melde('手机菜单-链接', '手机菜单-链接', this._pfad(ziel));
      }
    }

    // Woher der Link kommt: Tab › Gruppe › Link, Leiste › …, Tab › Kachel › …
    _pfad(link) {
      const name = beschriftung(link);
      if (link.closest('.viv-hm__leiste')) return 'Leiste › ' + name;
      if (link.closest('.viv-hm__head')) return 'Kopf › ' + name;
      if (link.closest('.viv-hm__kacheln')) return this.tabName + ' › Kachel › ' + name;
      const sub = link.closest('.viv-hm__sub');
      if (sub) return this.tabName + ' › ' + (sub.getAttribute('aria-label') || '') + ' › ' + name;
      const acc = link.closest('.viv-hm__acc');
      if (acc) return this.tabName + ' › ' + beschriftung(acc.querySelector('.viv-hm__acc-btn')) + ' › ' + name;
      return this.tabName + ' › ' + name;
    }

    _tabTaste(event) {
      const tabs = this.tabs;
      const jetzt = tabs.indexOf(document.activeElement);
      if (jetzt < 0) return;

      let neu = null;
      if (event.key === 'ArrowRight') neu = (jetzt + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') neu = (jetzt - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') neu = 0;
      else if (event.key === 'End') neu = tabs.length - 1;
      if (neu === null) return;

      event.preventDefault();
      this.zeigeTab(neu);
      tabs[neu].focus();
    }

    _element(knopf) {
      const id = knopf.getAttribute('aria-controls');
      return id ? this.querySelector('#' + CSS.escape(id)) : null;
    }

    zeigeTab(index) {
      this.schliesseUnterseite(true);
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      this.tabpanels.forEach((panel, i) => {
        panel.hidden = i !== index;
        if (i === index) panel.scrollTop = 0;
      });
    }

    klappe(knopf) {
      const liste = this._element(knopf);
      if (!liste) return false;
      const offen = knopf.getAttribute('aria-expanded') !== 'true';
      knopf.setAttribute('aria-expanded', String(offen));
      liste.hidden = !offen;
      return offen;
    }

    oeffneUnterseite(knopf) {
      const seite = this._element(knopf);
      if (!seite) return;

      this.schliesseUnterseite(true);
      this._oeffner = knopf;
      knopf.setAttribute('aria-expanded', 'true');
      seite.hidden = false;
      seite.scrollTop = 0;

      // Erst sichtbar machen, im nächsten Frame hineinschieben, damit der Übergang läuft.
      requestAnimationFrame(() => requestAnimationFrame(() => {
        seite.classList.add('is-offen');
        seite.querySelector('[data-viv-back]')?.focus({ preventScroll: true });
      }));
    }

    schliesseUnterseite(sofort) {
      const seite = this.querySelector('.viv-hm__sub:not([hidden])');
      if (!seite) return;

      const oeffner = this._oeffner;
      this._oeffner = null;
      oeffner?.setAttribute('aria-expanded', 'false');
      seite.classList.remove('is-offen');

      const verstecken = () => {
        if (!seite.classList.contains('is-offen')) seite.hidden = true;
      };
      if (sofort || ohneBewegung()) verstecken();
      else window.setTimeout(verstecken, 280);

      if (!sofort) oeffner?.focus({ preventScroll: true });
    }
  }

  window.customElements.define('viv-handy-menue', VivHandyMenue);
})();
